export function isHiddenMenu(name) {
  return window.CUSTOM_CONFIG && window.CUSTOM_CONFIG[window.CUSTOM_NAME].menus.includes(name);
}

export function isHiddenFunction(name) {
  return window.CUSTOM_CONFIG && window.CUSTOM_CONFIG[window.CUSTOM_NAME].function.includes(name);
}
